import { type ChangeEvent, type FocusEventHandler } from 'react';
import { noop, useUser } from 'libs';

interface TextProps {
  className?: string;
  disabled?: boolean;
  isPro?: boolean;
  name?: string;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  placeholder?: string;
  testId?: string;
  value: string | number | string[] | number[];
}

const Text = ({
  className = '',
  disabled = false,
  isPro = false,
  name = '',
  onBlur = noop,
  onChange,
  onFocus = noop,
  placeholder = '',
  testId,
  value,
}: TextProps) => {
  const user = useUser();
  return (
    <input
      type="text"
      className={`form-control ${className}`}
      data-testid={testId}
      disabled={disabled}
      name={name}
      value={value as any}
      placeholder={placeholder}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      readOnly={isPro && !user.features.is_pro}
    />
  );
};

export default Text;
